var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 1,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "#112347"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4726 23.0613L15.4726 23.0613C15.3653 22.9418 13.9829 21.3906 12.6303 19.3661C11.954 18.3538 11.2918 17.2331 10.8002 16.1214C10.3059 15.0035 10 13.9301 10 13.0027C10 9.96894 12.4689 7.5 15.5027 7.5C18.5364 7.5 21.0054 9.96894 21.0054 13.0027C21.0054 13.9301 20.6996 15.0035 20.2052 16.1214C19.7136 17.2331 19.0515 18.3538 18.3752 19.3661C17.0226 21.3906 15.6401 22.9418 15.5328 23.0613L15.5328 23.0613C15.5168 23.0791 15.4885 23.079 15.4726 23.0613ZM11.9826 13.0027C11.9826 14.9441 13.5613 16.5228 15.5027 16.5228C17.4441 16.5228 19.0228 14.9442 19.0228 13.0027C19.0228 11.0613 17.4441 9.4826 15.5027 9.4826C13.5613 9.4826 11.9826 11.0612 11.9826 13.0027Z",
    stroke: "#6C2AD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMap);
export default __webpack_public_path__ + "static/media/locationMap.b3fa98e8807a02d853b21e74b87e15fc.svg";
export { ForwardRef as ReactComponent };